import {
  EditOutlined,
  ArrowUpOutlined,
  PlusOutlined,
  DeleteOutlined,
  DollarOutlined,
  HistoryOutlined,
} from "@ant-design/icons";
import { Table, Button, message, Modal, Input, Card, Typography, Row } from "antd";
import { useTranslation } from "react-i18next";
import { animateScroll as scroll } from "react-scroll";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../Styles/GetProducts.css";
import "../Styles/ListPages.css";
import { formatCurrency } from "../../utils/formatters";
import { apiClient } from "../Api/AllApi";
import { apiDelete } from "../../utils/apiHelpers";

const { Title } = Typography;

const GetCustomer = () => {
  const [SearchText, setSearchText] = useState("");
  const { t } = useTranslation();
  const [dataSource, setDataSource] = useState([]);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);

  useEffect(() => {
    getApiProducts();
  }, []);
  const getApiProducts = async () => {
    try {
      const response = await apiClient.get('/customers');
      setDataSource(
        response.data.map((item) => ({
          id: item.id,
          name: item.name,
          email: item.email,
          total_owed: item.total_owed,
          phone_number: item.phone_number,
          type: item.type,
        }))
      );
    } catch (error) {
      console.error("Error fetching data:", error);
      message.error(t("fetchError"));
    }
  };

  const handleDelete = (id) => {
    setDeleteItemId(id);
    setIsDeleteModalVisible(true);
  };
  const handleConfirmedDelete = async () => {
    try {
      if (!deleteItemId) {
        message.error(t("noItemSelected"));
        return;
      }
      // Make the DELETE request using the centralized API helper
      await apiDelete(`customers/${deleteItemId}`);
      message.success(t("deleteSuccess"));
      await getApiProducts();
      setDeleteItemId(null);
      setIsDeleteModalVisible(false);
    } catch (error) {
      console.error("Error deleting customer:", error);
      message.error(t("deleteError"));
    }
  };

  const calculateTotalMoney = () => {
    return dataSource.reduce(
      (acc, item) => acc + parseFloat(item.total_owed || 0),
      0
    );
  };
  const formatDinar = (amount) => {
    return formatCurrency(amount, "IQD");
  };

  const columns = [
    {
      title: "ID",
      key: "index",
      render: (text, record, index) => index + 1,
      filteredValue: [SearchText],
      onFilter: (value, record, index) => {
        return (
          String(record.name).toLowerCase().includes(value.toLowerCase()) ||
          String(index + 1).includes(value)
        );
      },
    },
    {
      title: <b>{t("name")}</b>,
      dataIndex: "name",
      key: "name",
    },
    {
      title: <b>{t("email")}</b>,
      dataIndex: "email",
      key: "email",
    },
    {
      title: <b>{t("phoneNumber")}</b>,
      dataIndex: "phone_number",
      key: "phone_number",
    },
    {
      title: <b>{t("totalOwed")}</b>,
      dataIndex: "total_owed",
      key: "total_owed",
      render: (text) => <span>{formatDinar(text)}</span>,
    },
    {
      title: <b>{t("type")}</b>,
      dataIndex: "type",
      key: "type",
      render: (text, record) => {
        let customerType = t("unknown");
        if (record.type === "individual") customerType = t("individual");
        else if (record.type === "company") customerType = t("company");
        else if (record.type === "organization")
          customerType = t("organization");
        return customerType;
      },
    },
    {
      title: <b>{t("کردارەکان")}</b>,
      key: "actions",
      width: '300px',
      align: 'center',
      render: (text, record) => (
        <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
          <Button danger size="small" onClick={() => handleDelete(record.id)}>
            <DeleteOutlined />
          </Button>
          <Link to={`/GetCustomer/UpdateCustomer/${record.id}`}>
            <Button type="primary" size="small" icon={<EditOutlined />} />
          </Link>
          <Link to={`/GetCustomer/Payment/${record.id}`}>
            <Button
              type="primary"
              size="small"
              icon={<DollarOutlined />}
              style={{
                backgroundColor: "#28a745",
                borderColor: "#28a745",
              }}
            />
          </Link>
          <Link to={`/GetCustomer/IncreasePayment/${record.id}`}>
            <Button
              type="primary"
              size="small"
              icon={<DollarOutlined />}
              style={{
                backgroundColor: "#007bff",
                borderColor: "#007bff",
              }}
            />
          </Link>
          <Link to={`/GetCustomer/OrderHistory/${record.id}`}>
            <Button
              type="primary"
              size="small" 
              icon={<HistoryOutlined />}
              style={{
                backgroundColor: "#6435c9",
                borderColor: "#6435c9",
              }}
            />
          </Link>
          <Link to={`/GetCustomer/CustomerPaymentHistory/${record.id}`}>
            <Button
              type="primary"
              size="small"
              icon={<DollarOutlined />}
              style={{
                backgroundColor: "#ffc107",
                borderColor: "#ffc107",
              }}
            />
          </Link>
        </div>
      ),
    },
        {
      title: <b>{t("کۆی گشتی پارەی دراو")}</b>,
      key: "combinedPayments",
      width: '180px',
      align: 'center',
      render: (text, record) => (
        <Link to={`/GetCustomer/CombinedPayments/${record.id}`}>
          <Button
            type="primary"
            size="small"
            style={{
              backgroundColor: "#17a2b8",
              borderColor: "#17a2b8",
            }}
          >
            {t("View")}
          </Button>
        </Link>
      ),
    },
  ];

  const scrollToTop = () => {
    scroll.scrollToTop();
  };

  return (
    <div className="list-page" style={{ padding: "20px" }}>
      <Card
        style={{
          marginBottom: "20px",
          background: "#f8fafc",
          borderRadius: "12px",
          padding: "20px",
          border: "1px solid #e2e8f0",
          boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Title level={3} style={{ margin: 0 }}>
            {t("customers")}
          </Title>
          <div>
            <Button
              type="primary"
              style={{ marginRight: "10px" }}
              onClick={scrollToTop}
            >
              <ArrowUpOutlined />
            </Button>
            <Link to="/AddCustomer">
              <Button type="primary">
                <PlusOutlined /> {t("زیاد کردنی کڕیار")}
              </Button>
            </Link>
          </div>
        </div>

        <Input.Search
          placeholder={t("searchHere")}
          style={{
            marginTop: "20px",
            width: "300px",
          }}
          allowClear
          onSearch={(value) => setSearchText(value)}
          onChange={(e) => setSearchText(e.target.value)}
        />
      </Card>

      <Card
        style={{
          marginBottom: "20px",
          borderRadius: "12px",
          padding: "20px",
          boxShadow: "0 1px 3px rgba(0,0,0,0.06), 0 4px 12px rgba(0,0,0,0.04)",
          border: "1px solid #e2e8f0",
        }}
      >
        <Table
          dataSource={dataSource.map((item) => ({ ...item, key: item.id }))}
          columns={columns}
          pagination={{ pageSize: 50 }}
          scroll={{ x: 800 }}
        />
      </Card>

      <Card
        style={{
          background: "linear-gradient(135deg, #0ea5e9 0%, #1e3a5f 100%)",
          borderRadius: "12px",
          padding: "16px 20px",
          textAlign: "center",
          fontSize: "1.25rem",
          fontWeight: "bold",
          color: "white",
          boxShadow: "0 4px 12px rgba(14, 165, 233, 0.3)",
          marginTop: "20px",
          border: "none",
        }}
      >
        {t("کۆی گشتی قەرزاران")}: <br />
        <span
          style={{
            fontSize: "26px",
            fontWeight: "600",
            marginTop: "10px",
            display: "inline-block",
          }}
        >
          {formatDinar(calculateTotalMoney())}
        </span>
      </Card>

      <Modal
        title={t("confirmDelete")}
        open={isDeleteModalVisible}
        onOk={handleConfirmedDelete}
        onCancel={() => setIsDeleteModalVisible(false)}
        okText={t("yesDelete")}
        cancelText={t("cancel")}
        centered
      >
        <p>{t("deleteConfirmation")}</p>
      </Modal>
    </div>
  );
};

export default GetCustomer;
